// The public website, for links out of the app (join the waitlist, legal pages). Set VITE_SITE_URL at build time.
export const SITE_URL = (import.meta.env.VITE_SITE_URL ?? 'http://server:47120').replace(/\/$/, '')

/** Where people write when something in the app breaks (the error page's Email support). */
export const SUPPORT_EMAIL = 'support@rowcall.ai'
